import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder"
import { cn } from "@/common/utils/cn"
import { formatDate } from "@/common/utils/formatters"
import { differenceInDays as differenceInDaysFns } from "date-fns"
import { BriefcaseBusiness, UserRoundIcon } from "lucide-react"
import { Tooltip } from "react-tooltip"
import { twMerge } from "tailwind-merge"

export type CardProps = {
  card: {
    id: string
    display_name: string
    observations: string
    updatedAt?: string
    created_at: string
    creator: {
      full_name: string
      profile_picture: {
        content_type?: string
        url: string
      }
    },
    last_state_change_log?: {
      message?: string
      created_at: string
    },
  },
  onClick?: (x: string) => void
}

const Card = ({
  onClick,
  card: {
    id,
    display_name,
    created_at,
    creator: {
      full_name,
      profile_picture: {
        url
      }
    },
    last_state_change_log,
  }
}:CardProps ) => {
  const differenceInDays = differenceInDaysFns(new Date(), new Date(last_state_change_log?.created_at ?? new Date()))

  return (
    <div data-testid="lead_card" className={twMerge("w-full rounded-lg", !!onClick && 'cursor-pointer')} onClick={() => onClick && onClick(id)}>
      <div className="flex items-start gap-2 p-4 bg-white-100 rounded-t-lg">
        <div className="w-[24px] h-[24px] bg-white-800 rounded-full flex justify-center items-center">
          <BriefcaseBusiness size={14} color="#000000" />
        </div>
        <span className="font-bold text-sm max-w-[115px] break-words">{display_name}</span>
      </div>
      <div
        data-testid="background_lead_card"
        className={cn(
          "bg-blue-300 flex flex-col gap-2 rounded-b-lg p-4",
          differenceInDays > 1 && 'bg-yellow-op-2',
          differenceInDays > 2 && 'bg-red-op-2'
        )}
        data-tooltip-id={`card-${id}`}
      >
        <div>
          <p className="text-xs break-words mb-0">{last_state_change_log?.message || ''}</p>
          <span className="text-[11px] italic">Cadastrado em {formatDate(new Date(created_at))}</span>
        </div>
        <div className="flex gap-1">
          <ImageWithPlaceholder
            url={url}
            alt={full_name}
            placeholderIcon={UserRoundIcon}
            />
          <span className="text-xs">{full_name}</span>
        </div>
      </div>
      {differenceInDays > 1 && (
        <Tooltip
          id={`card-${id}`}
          data-testid="tooltip-days-without-update"
          content={`O credenciamento está sem progresso há ${differenceInDays} dias.`}
          // delayShow={300}
          place="top-start"
        />
      )}
    </div>
  )
}

export default Card
